export function match(param) {
  return /^\d+$/.test(param)
}
